
export interface Thread {
  id: string;
  title: string;
  content: string;
  category: string;
  created_at: string;
  user_id: string;
  club_id: string;
  reply_count: number;
  author: {
    id: string;
    full_name?: string;
    username?: string;
    avatar_url?: string;
  };
  liked?: boolean;
  likes_count: number;
}

export interface ThreadReply {
  id: string;
  thread_id: string;
  content: string;
  created_at: string;
  user_id: string;
  author?: {
    id: string;
    full_name?: string;
    username?: string;
    avatar_url?: string;
  };
}

export const THREAD_CATEGORIES = [
  "General", 
  "Questions", 
  "Resources", 
  "Projects", 
  "Events", 
  "Announcements",
  "Introductions"
];
